import list from './list';
import total from './total';
import totalEmpOrg from './totalEmpOrg';
import term from './term';
import year from './year';
import comments from './comments';
import commentsSimple from './commentsSimple';
import listAll from './listAll';
import analysis from './analysis';
import totalDate from './totalDate';
import totalClass from './totalClass';
import log from './log';
import totalForEvaluator from './totalForEvaluator'; 
import commentsWordCount from './commentsWordCount'; 
import questionnaireAnalysis from './questionnaireAnalysis'; 

export default {
    list,
    total,
    totalEmpOrg,
    term,
    year,
    comments,
    commentsSimple,
    listAll,
    analysis,
    totalDate,
    totalClass,
    log,
    totalForEvaluator,
    commentsWordCount,
    questionnaireAnalysis
}